import { format as dateFnsFormat, parseISO } from 'date-fns';

// Format currency to Euros
export const formatCurrency = (amount) => {
  return `€${Number(amount).toFixed(2)}`;
};

// Format date to DD/MM/YYYY
export const formatDate = (date) => {
  if (!date) return '';
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  return dateFnsFormat(dateObj, 'dd/MM/yyyy');
};

// Format date for display with month name (e.g., "25 Dec 2024")
export const formatDateShort = (date) => {
  if (!date) return '';
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  return dateFnsFormat(dateObj, 'dd MMM yyyy');
};

// Format date range
export const formatDateRange = (startDate, endDate) => {
  if (!startDate || !endDate) return '';
  const start = typeof startDate === 'string' ? parseISO(startDate) : startDate;
  const end = typeof endDate === 'string' ? parseISO(endDate) : endDate;
  
  if (start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear()) {
    return `${dateFnsFormat(start, 'dd')} - ${dateFnsFormat(end, 'dd MMM yyyy')}`;
  }
  return `${dateFnsFormat(start, 'dd MMM')} - ${dateFnsFormat(end, 'dd MMM yyyy')}`;
};
